export default "__VITE_ASSET__DNEu0z7___"